import FetchTomFiltersQuery from '@/application/tom/fetchTomFilters/FetchTomFiltersQuery';
import TomList from '@/domain/tom/clasification/TomList';

export default class {
  public invoke(query: FetchTomFiltersQuery): string[] {
    const listCollection: TomList[] = TomList.all();
    return listCollection.map((list: TomList) => list.toString());
  }
}
